export default __webpack_public_path__ + "static/O0006-e6fef5e5f3987f7eb2aff9038d5a3013.png";